module.exports = __webpack_public_path__ + "img/双软认证企业.c68baead.jpg";